module.exports = __webpack_public_path__ + "static/media/react.d540be25.svg";